
import { TypeOrmModule } from '@nestjs/typeorm';
import { forwardRef, Module } from '@nestjs/common';
import { DevelopmentStatusEntity } from './developmentpost.entity';
import { DevelopmentpostController } from './developmentpost.controller';
import { DevelopmentpostService } from './developmentpost.service';
import { PostEntity } from '../post/post.entity';



@Module({
  imports: [
    TypeOrmModule.forFeature([DevelopmentStatusEntity,PostEntity]),
  ],
  controllers: [DevelopmentpostController],
  providers: [DevelopmentpostService],
  exports:[DevelopmentpostService]
})
export class DevelopmentstatusModule {}